import { render, staticRenderFns } from "./ConfirmSSOSynchroDialog.vue?vue&type=template&id=37ea91ea&scoped=true"
import script from "./ConfirmSSOSynchroDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmSSOSynchroDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmSSOSynchroDialog.vue?vue&type=style&index=0&id=37ea91ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea91ea",
  null
  
)

export default component.exports